import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanRestrictComponent } from './plan-restrict/plan-restrict.component';


@NgModule({
  declarations: [PlanRestrictComponent],
  imports: [
    CommonModule
  ],
  exports: [PlanRestrictComponent]
})
export class PlanRestricModule { }
